<template>
	<Application :loading="loading" v-model:error-title="errorTitle" :error-detail="errorDetail" v-model:success-title="successTitle" :success-detail="successDetail" :isSideBarFixed="isSideBarFixed">
		<template #navbar>
			<v-row align="center" class="flex-nowrap" style="white-space:nowrap; overflow:hidden;">
				<v-btn id="btnBack" elevation="0" style="background-color:transparent;" @click="goback()">
					<v-icon>mdi-chevron-left</v-icon>
				</v-btn>
				<v-row justify="center">
					<h1>{{ getTicketCategoryTitle() }}</h1>
				</v-row>
			</v-row>
		</template>

		<SideBar :actions="sidebarActions" :translations="translationStatuses" displayEditTranslations @action="handleAction($event)" @edit:translations="$refs.form?.openTranslationWizard()" />

		<!-- Ticket Category Detail -->
		<Disclosure :title="$t('text.ticketCategory')" data-cy="ticketCategoryInfo" ref="SECTION_ticketCategoryInfo" v-if="ticketCategory && ticketCategory.fields" :expanded="true" style="margin-top: 64px;">
			<TicketCategoryForm
				ref="form"
				v-model="ticketCategory"
				v-model:loading="loading"
				@saved="onFormSaved"
			/>
		</Disclosure>
	</Application>
</template>

<script>
import Loading from 'vue-loading-overlay'
import SideBar from "@/components/common/SideBar.vue"
import Alert from '@/components/common/Alert.vue'
import Disclosure from '@/components/common/Disclosure.vue'
import LanguageFlag from '@/components/common/LanguageFlag.vue'
import MediaCard from '@/components/media/MediaCard.vue'
import FileUpload from "@/components/media/FileUpload.vue"
import Dialog from '@/components/common/Dialog.vue'
import Common from '@/mixins/Common.vue'
import Application from '../Application.vue'
import TicketCategoryForm from './TicketCategoryForm.vue'

export default {
	mixins: [ Common ],
	components: { Loading, SideBar, Alert, Disclosure, LanguageFlag, MediaCard, FileUpload, Dialog, Application, TicketCategoryForm },
	props: {
		ticketCategoryId: String
	},
	data() {
		return {
			loading: false,
			errorTitle: '',
			errorDetail: '',
			successTitle: '',
			successDetail: '',

			ticketCategory: {
				sys: { id: '' },
				fields: {
					title: { de: '', en: '', fr: '', it: '', nl: '' },
					ageGroupEnabled: { de: false },
					minAge: { de: null },
					maxAge: { de: null },
					freeTourGuide: { de: false },
					flatRate: { de: false },
				}
			},
		}
	},

	async mounted() {
		if (this.ticketCategoryId) {
			// Wait for next tick to ensure form ref is available
			await this.$nextTick()
			await this.$refs.form?.loadTicketCategory(this.ticketCategoryId)
		}
	},

	computed: {
		requiredTranslationLocaleCodes() {
			return this.getRequiredTranslationLocaleCodes()
		},
		sidebarActions() {
			let actions = []
			actions.push({ icon: 'mdi-check', style: 'blue', dark: true, title: this.$t('text.saveChanges'), function: 'upsertTicketCategory'})
			actions.push({ icon: 'mdi-delete', style: 'red', dark: true, title: this.$t('text.deleteTicketCategory'), function: 'deleteTicketCategory', params: [ this.ticketCategory ]})
			return actions
		},
		translationStatuses() {
			return this.getTranslationStatus2(this.translatableFields, 'model', this.requiredTranslationLocaleCodes)
		},
		translatableFields() {
			return [
				{ typeName: 'Reduction2', fieldName: 'title', value: this.ticketCategory.fields.title },
			]
		},
	},

	methods: {
		handleAction(event) {
			this[event.function](event.params)
		},
		goback() {
			this.$router.push('/reductions')
		},
		locked(category) {
			if (category?.fields?.locked?.de) {
				return category.fields.locked.de
			}
			return false
		},
		getTicketCategoryTitle() {
			return this.ticketCategory?.fields?.title[this.selectedLocale]
		},
		async upsertTicketCategory() {
			const result = await this.$refs.form.save()
			if (result && !this.ticketCategoryId) {
				this.$router.push({ path: this.$route.path, query: { ticketCategoryId: result.sys.id } })
				this.ticketCategory.sys = result.sys
			}
		},
		onFormSaved() {
			this.successTitle = this.$t('text.ticketCategory')
			this.successDetail = this.ticketCategoryId ? this.$t('text.ticketCategoryUpdated') : this.$t('text.ticketCategoryCreated')
		},
		async deleteTicketCategory([category]) {
			this.loading = true

			const data = {
				option: category,
				clientId: this.$store.state.selectedClient.sys.id,
				serviceProviderId: this.userIsOperator ? undefined : this.$store.state.selectedServiceProvider.sys.id,
			}

			try {
				await this.axios.delete('/option', {
					headers: this.requestHeaders(),
					data
				})

				//Update Client in Local Storage
				const clientRes = await this.$httpGet(`/client/${this.$store.state.selectedClient.sys.id}`)
				await this.$store.commit('setSelectedClient', clientRes.client)
				
				this.successTitle = this.$t('text.SUCCESS')
				this.successDetail = this.$t('text.ticketCategoryDeletedSuccessDetails')
				
				this.sleep(2000).then(() => { 
					this.$router.push('/reductions')
				})
			}
			catch (error) {
				if (error.response?.data?.message === 'category in use') {
					this.showError(this.$t('text.ticketCategoryInUseError'))
				} else if (error.response?.data?.message === 'category in use by product') {
					this.showError(this.$t('text.ticketCategoryInUseByProductError'))
				}
			}
			
			this.loading = false
		},
		sleep(ms) {
			return new Promise(resolve => setTimeout(resolve, ms));
		},
		setLocale(code) {
			this.serviceLocale = code
		},
	}
}
</script>

<style lang="scss" scoped>
.flag { position: absolute; z-index: 10; margin-top: 30px; margin-left: -26px; zoom: 0.8; }
.entry { border: 1px solid #ccc; margin-bottom: 10px; border-radius: 5px; padding: 5px; }
.serviceLocale { position: absolute; z-index: 10; margin-top: 32px; margin-left: -32px; zoom: 0.8; }
</style>